export default __webpack_public_path__ + "static/media/ic-infusion-chairs.41766f33.svg";